/* ==========================================================================
   tff-shell.js — 10-02 (operator 6:35 PM PST): an episode that is playing KEEPS PLAYING whatever
   the visitor opens. The home page is the one shell; nothing inside the site does a page load.

   - Tabs (DVDs, Episodes, App, Markets) were already views of this page (ffShowTab).
   - Every same-site page — /pages/*, /products/*, /collections/*, /policies/*, /blogs/*, /search,
     /cart — opens as the 'page' view (#ffPage): its HTML is fetched, the page's #pageContent is
     put into the panel and its scripts are run. The address bar reads /?view=<path>&<its query>,
     so a reload or a shared link comes back to the same view, and Back/Forward move between views.
   - Arriving straight on one of those pages (a link from outside) is sent to the shell first by a
     small script in layout/theme.liquid's <head> (before anything is drawn), so the shell is
     always what is running. ?ffshell=0 opts out (the fallback if a fetch fails).
   - Leaving the site (payment pages, Apple sign-in, outside links) while audio plays opens a new
     tab or a pop-up instead (window.ffLeave), so this one keeps playing.
   ========================================================================== */
(function () {
  var SHELL = /^\/(pages|products|collections|policies|blogs|search|cart)(\/|$)/;
  var HOME_TITLE = document.title;
  var seq = 0;
  function $(id) { return document.getElementById(id); }
  function playing() { var a = $('audioElement'); return !!(a && a.src && !a.paused && !a.ended); }

  /* Leave the site without stopping the episode: a new tab while audio plays. */
  window.ffLeave = function (url) {
    if (playing()) { var w = window.open(url, '_blank'); if (w) { try { w.opener = null; } catch (e) {} return; } }
    window.location.assign(url);
  };

  function viewURL(u) {
    var q = u.search.replace(/^\?/, '');
    return '/?view=' + encodeURIComponent(u.pathname) + (q ? '&' + q : '') + u.hash;
  }
  /* The page URL a /?view= address stands for. */
  function pageFromView(loc) {
    var u = new URL(loc.href), path = u.searchParams.get('view');
    if (!path || !SHELL.test(path)) return null;
    u.searchParams.delete('view');
    var q = u.searchParams.toString();
    return new URL(path + (q ? '?' + q : '') + u.hash, location.origin);
  }

  /* The transcript page loads the seven transcript files itself. The shell has them already (or is
     loading them): appending them again would add every episode twice to window.db. While its
     scripts run, those requests are answered from what is loaded. */
  function dbReady() { return !!(window.db && window.db.length && window.episodes === window.db); }
  function withTranscriptShim(run) {
    var body = document.body, orig = body.appendChild;
    body.appendChild = function (n) {
      if (n && n.tagName === 'SCRIPT' && /data_part/.test(n.src || '')) {
        (function wait() { if (dbReady()) { if (n.onload) n.onload(); } else setTimeout(wait, 250); })();
        return n;
      }
      return orig.call(this, n);
    };
    try { return run(); } finally { body.appendChild = orig; }
  }

  function runScripts(panel, path) {
    var list = Array.prototype.slice.call(panel.querySelectorAll('script'));
    var chain = Promise.resolve();
    list.forEach(function (old) {
      chain = chain.then(function () {
        return new Promise(function (done) {
          var s = document.createElement('script');
          for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
          if (old.src) { s.onload = s.onerror = function () { done(); }; old.parentNode.replaceChild(s, old); return; }
          s.text = old.textContent;
          var put = function () { old.parentNode.replaceChild(s, old); };
          if (path === '/pages/transcript') withTranscriptShim(put); else put();
          done();
        });
      });
    });
    return chain;
  }

  /* Open a same-site page as the 'page' view. opts.history: 'push' (default) | 'replace' | 'none'. */
  function open(href, opts) {
    opts = opts || {};
    var u = new URL(href, location.href);
    var my = ++seq;
    var addr = viewURL(u);
    try {
      if (opts.history === 'replace') history.replaceState({ ffview: 1 }, '', addr);
      else if (opts.history !== 'none') history.pushState({ ffview: 1 }, '', addr);
    } catch (e) {}
    var panel = $('ffPage'); if (!panel) { location.assign(u.pathname + u.search + (u.search ? '&' : '?') + 'ffshell=0'); return; }
    panel.innerHTML = '<div class="ff-page-loading" role="status"><i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i> Loading…</div>';
    window.ffShowTab('page');
    var mc = $('mainContainer'); if (mc) mc.scrollTop = 0;
    return fetch(u.pathname + u.search, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok && r.status !== 404) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      if (my !== seq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.getElementById('pageContent');
      if (!src) throw new Error('no #pageContent');
      panel.innerHTML = '';
      Array.prototype.forEach.call(src.childNodes, function (n) { panel.appendChild(document.importNode(n, true)); });
      document.title = doc.title || HOME_TITLE;
      if (u.hash) { var t = document.getElementById(decodeURIComponent(u.hash.slice(1))); if (t) t.scrollIntoView(); }
      return runScripts(panel, u.pathname);
    }).catch(function () {
      if (my !== seq) return;
      /* Could not draw it here: a real visit is better than nothing (it says so if audio would stop). */
      if (playing()) window.open(u.pathname + u.search + (u.search ? '&' : '?') + 'ffshell=0', '_blank');
      else location.assign(u.pathname + u.search + (u.search ? '&' : '?') + 'ffshell=0');
    });
  }
  window.ffShellOpen = open;

  /* A home-page address (/?tab=…&item=…) shown without a load. */
  function home(u, opts) {
    opts = opts || {};
    var p = u.searchParams;
    if (p.get('view')) { var pg = pageFromView(u); if (pg) { open(pg.href, opts); return; } }
    var t = p.get('tab');
    var epLink = ['archives', 'search', 'q', 'ep', 'id', 't'].some(function (k) { return p.has(k); });
    var pt = window.ffPathTab ? window.ffPathTab(u.pathname) : '';
    var tab = pt || ((t === 'dvds' || t === 'store') ? 'discs' : (t || (epLink ? 'episodes' : 'discs')));
    if (p.get('item') && typeof window.ffDiscsWant === 'function') { window.ffDiscsWant(p.get('item')); tab = 'discs'; }
    seq++;
    if (opts.history !== 'none') { try { history.pushState({}, '', u.pathname + u.search + u.hash); } catch (e) {} }
    document.title = HOME_TITLE;
    window.ffShowTab(tab, { silent: opts.history === 'none' });
    if (p.get('archives') === '1' && typeof toggleMobileArchives === 'function' && window.innerWidth < 768) toggleMobileArchives();
  }
  window.ffShellHome = home;

  /* Every same-site link is a view of this page. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download')) return;
    var href = a.getAttribute('href') || '';
    if (/^(mailto:|tel:|javascript:|#)/i.test(href)) return;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
    var newTab = a.target && a.target !== '_self';
    if (u.origin !== location.origin) {
      /* an outside link in this tab would end the episode: a new tab instead, while audio plays */
      if (!newTab && playing() && /^https?:$/.test(u.protocol)) { e.preventDefault(); window.open(u.href, '_blank', 'noopener'); }
      return;
    }
    if (newTab) return;
    if (u.pathname === '/' || (window.ffPathTab && window.ffPathTab(u.pathname))) {
      if (u.search === location.search && u.pathname === location.pathname && u.hash) return; /* an in-page anchor */
      e.preventDefault(); home(u); return;
    }
    if (SHELL.test(u.pathname)) { e.preventDefault(); open(u.href); return; }
    /* other same-site addresses are real page loads (Shopify checkout, accounts): a new tab while audio plays */
    if (playing()) { e.preventDefault(); window.open(u.href, '_blank'); }
  });

  /* A form that would load a page (the cart page's Checkout, a fallback product form) goes to a new
     tab while audio plays. Forms whose own script handles the submit (fetch) are left alone. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || !playing()) return;
    if (!f.target || f.target === '_self') f.target = '_blank';
  }, true);

  /* Back / Forward between views. */
  window.addEventListener('popstate', function () {
    var pg = pageFromView(location);
    if (pg) open(pg.href, { history: 'none' }); else home(new URL(location.href), { history: 'none' });
  });

  /* theme.js opens a transcript in a new tab; here it is a view of this page. */
  var _open = window.open;
  window.open = function (url, target, feat) {
    try {
      var u = new URL(url, location.href);
      if (u.origin === location.origin && u.pathname === '/pages/transcript') { open(u.href); return null; }
    } catch (e) {}
    return _open.apply(window, arguments);
  };

  /* The page title follows the view. */
  if (typeof window.ffShowTab === 'function') {
    var st = window.ffShowTab;
    window.ffShowTab = function (tab) { var r = st.apply(this, arguments); if (tab !== 'page') document.title = HOME_TITLE; return r; };
  }
})();
